var _rect, _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMedicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#CFE7FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4991 12.4941H24.5008C25.6058 12.4941 26.5016 13.3899 26.5016 14.495V18.4966C26.5016 20.7067 24.71 22.4983 22.5 22.4983V22.4983C20.2899 22.4983 18.4983 20.7067 18.4983 18.4966V14.495C18.4983 13.3899 19.3941 12.4941 20.4991 12.4941Z",
    stroke: "#0A5190",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6018 21.9043L25.3451 24.8775",
    stroke: "#0A5190",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4001 21.9043L19.6568 24.8775",
    stroke: "#0A5190",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4984 24.6562V28.5013",
    stroke: "#0A5190",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.4983,
    cy: 30.0026,
    r: 1.50063,
    stroke: "#0A5190",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5017 24.6562V28.5013",
    stroke: "#0A5190",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7785 31.5032C24.5992 31.2001 24.5034 30.8549 24.5009 30.5028V30.5028C24.5009 29.3978 25.3967 28.502 26.5017 28.502V28.502C27.6067 28.502 28.5025 29.3978 28.5025 30.5028V30.5028C28.5 30.8549 28.4042 31.2001 28.2249 31.5032",
    stroke: "#0A5190",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5016 16.4963H18.4983",
    stroke: "#0A5190",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4962 29.5025V28.1178C13.4962 26.687 14.5061 25.4552 15.9091 25.1747L18.7564 24.6055C18.9917 24.5584 19.236 24.6066 19.4357 24.7396V24.7396C21.2911 25.9771 23.7088 25.9771 25.5642 24.7396V24.7396C25.764 24.6066 26.0083 24.5584 26.2435 24.6055L29.0909 25.1747C30.4938 25.4552 31.5037 26.687 31.5037 28.1178V29.5025",
    stroke: "#0A5190",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicIcon);
export default __webpack_public_path__ + "static/media/medicIcon.15dc7c7da593eeba80ceabdec1a83e43.svg";
export { ForwardRef as ReactComponent };